import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { DetailedRouteMap } from './DetailedRouteMap';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { strings } from '../../resources/strings';

export class RouteDetailedView extends Component {
    static contextTypes = {
        getLogo: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            displayTripInfo: true,
            displayMap: true
        }
    }

    componentDidMount() {
        /*
         * Set function to handle when window is resized and immediately call it so we check the current screen size, otherwise it is only
         * triggered on resize.
        */
        window.onresize = () => this.resize();
        this.resize();
    }

    componentWillUnmount() {
        window.onresize = () => { };
    }

    //-------

    resize() {
        if (window.innerWidth > 767) {
            this.setState({
                displayTripInfo: true,
                displayMap: true
            });
        } else {
            document.getElementById("route-detailed-view-show-trip-button").click();
        }
    }

    determineTripIcon(trip) {
        if (trip.subTrips.length === 1 && trip.subTrips[0].isWalking) {
            return "icons/walking.png";
        } else {
            return "icons/bus.png";
        }
    }

    determineLineCode(trip) {
        const subtrip = trip.subTrips.find(st => undefined !== st && null !== st.lineCode && undefined !== st.lineCode);
        if (undefined !== subtrip) {
            return subtrip.lineCode;
        }

        return "";
    }

    displayTripInfo() {
        this.setState({
            displayTripInfo: true,
            displayMap: false
        });
    }

    displayMap() {
        this.setState({
            displayTripInfo: false,
            displayMap: true
        });
    }

    //RENDER
    renderDisplay() {
        const { displayTripInfo, displayMap } = this.state;
        const { trip } = this.props;

        if (displayTripInfo && displayMap) {
            return (
                <Row>
                    <Col sm={5} className="route-detailed-view-container-passings-col">
                        {this.renderInfo(trip)}
                    </Col>
                    <Col sm={7} className="route-detailed-view-container-map-col">
                        <DetailedRouteMap trip={trip} />
                    </Col>
                </Row>
            );
        } else {
            if (displayTripInfo) {
                return (
                    <Row>
                        <Col sm={12} className="route-detailed-view-container-passings-col">
                            {this.renderInfo(trip)}
                        </Col>
                    </Row>
                );
            } else {
                return (
                    <Row>
                        <Col sm={12} className="route-detailed-view-container-map-col">
                            {this.renderHeader(trip)}
                            <DetailedRouteMap trip={trip} />
                        </Col>
                    </Row>
                );
            }
        }
    }

    renderInfo(trip) {
        if (undefined === trip) {
            return null;
        }

        return (
            <div>
                {this.renderHeader(trip)}
                {this.renderTripInfo(trip)}
            </div>
        );
    }

    renderHeader(trip) {
        const { onReturn } = this.props;
        const { displayMap, displayTripInfo } = this.state;

        return (
            <div>
                <Button className="plan-route-detailed-view-back-button margin-bottom-10" variant="light" onClick={() => onReturn()}>
                    <div className={"icon-redo"} />
                </Button>

                <div className="route-detailed-view-small-screen-tabs">
                    <Button id="route-detailed-view-show-trip-button" className={`route-detailed-view-small-screen-tabs-link-button ${displayTripInfo ? "orange-text" : ""}`} variant="link" onClick={() => this.displayTripInfo()}>
                        {strings.showTrip}
                    </Button>
                    <span className="orange-text">|</span>
                    <Button id="route-detailed-view-show-map-button" className={`route-detailed-view-small-screen-tabs-link-button ${displayMap ? "orange-text" : ""}`} variant="link" onClick={() => this.displayMap()}>
                        {strings.showMap}
                    </Button>
                </div>

                <Row className="margin-left-5 align-items-center width-95">
                    <Col xs={2} sm={2} className="text-align-end">
                        <img src={this.determineTripIcon(trip)} alt="" height="30px" width="30px" />
                    </Col>
                    <Col xs={7} sm={8} className="plan-route-trips-list-trip-header-route-info">
                        <div className="d-flex-inline text-truncate">
                            <b>{this.determineLineCode(trip)}</b> {trip.endPlace.name}
                        </div>
                    </Col>
                    <Col xs={3} sm={2} className="plan-route-trips-list-trip-header-duration-info">
                        {trip.totalTripDuration}
                    </Col>
                </Row>
            </div>
        );
    }

    renderTripInfo(trip) {
        return (
            <div className="plan-route-detailed-view-trip-info">
                {
                    trip.subTrips.map((subtrip, index) => {
                        if (index === 0) {
                            if (trip.subTrips.length - 1 === index) {
                                return this.renderSingleSubtrip(trip, subtrip);
                            } else {
                                return this.renderFirstSubtrip(trip, subtrip);
                            }
                        } else if (trip.subTrips.length - 1 === index) {
                            return this.renderLastSubtrip(trip, subtrip);
                        } else {
                            return this.renderIntermediateSubtrip(subtrip, index);
                        }
                    })
                }
            </div>
        );
    }

    renderSingleSubtrip(trip, subtrip) {
        const { getLogo } = this.context;

        return (
            <div key={`single-trip-${trip.startPlace.name}-${trip.endPlace.name}`}>
                <img src="icons/prOrigin.png" alt="" width="20px" height="20px" />
                &nbsp;
                <b>{subtrip.departureTimeToShow} - {trip.startPlace.name}</b>

                {
                    subtrip.isWalking ?
                        <div className="padding-top-10 padding-bottom-10">
                            <img src="icons/walking.png" alt="" width="20px" height="20px" />
                            <span>Ir a pé {subtrip.walkingTime}, {subtrip.distance}m</span>
                        </div>
                        :
                        //TO DO: Use transport types here
                        <div className="padding-top-10 padding-bottom-10" >
                            <img src="icons/bus.png" alt="" width="20px" height="20px" />
                            &nbsp;
                            <img src={getLogo(subtrip.provider)} alt={subtrip.provider} width="20px" height="20px" />
                            &nbsp;
                            <span>{subtrip.lineCode} {subtrip.passings[0].destination}</span>
                        </div>
                }

                <img src="icons/prDestination.png" alt="" width="20px" height="20px" />
                &nbsp;
                <b>{subtrip.arrivalTimeToShow} - {trip.endPlace.name}</b>
            </div>
        );
    }

    renderFirstSubtrip(trip, subtrip) {
        const { getLogo } = this.context;

        return (
            <div key={`first-subtrip-${trip.startPlace.name}-${trip.endPlace.name}-${subtrip.order}`}>
                <img src="icons/prOrigin.png" alt="" width="20px" height="20px" />
                &nbsp;
                <b>{subtrip.departureTimeToShow} - {trip.startPlace.name}</b>

                {
                    subtrip.isWalking ?
                        <div className="padding-top-10 padding-bottom-10">
                            <img src="icons/walking.png" alt="" width="20px" height="20px" />
                            <span>Ir a pé {subtrip.walkingTime}, {subtrip.distance}m</span>
                        </div>
                        :
                        //TO DO: Use transport types here
                        <div className="padding-top-10 padding-bottom-10" >
                            <img src="icons/bus.png" alt="" width="20px" height="20px" />
                            &nbsp;
                            <img src={getLogo(subtrip.provider)} alt={subtrip.provider} width="20px" height="20px" />
                            &nbsp;
                            <span>{subtrip.passings[0].destination}</span>
                        </div>
                }

                <img src="icons/prIntermediate.png" alt="" width="15px" height="15px" />
                &nbsp;
                <span>{subtrip.passings[subtrip.passings.length - 1].name}</span>

            </div>
        );
    }

    renderIntermediateSubtrip(subtrip, index) {
        const { getLogo } = this.context;

        return (
            <div key={`intermediate-subtrip-${index}`}>
                {
                    subtrip.isWalking ?
                        <div className="padding-top-10 padding-bottom-10">
                            <img src="icons/walking.png" alt="" width="20px" height="20px" />
                            <span>Ir a pé {subtrip.walkingTime}, {subtrip.distance}m</span>
                        </div>
                        :
                        //TO DO: Use transport types here
                        <div className="padding-top-10 padding-bottom-10" >
                            <img src="icons/bus.png" alt="" width="20px" height="20px" />
                            &nbsp;
                            <img src={getLogo(subtrip.provider)} alt={subtrip.provider} width="20px" height="20px" />
                            &nbsp;
                            <span>{subtrip.lineCode} {subtrip.passings[0].destination}</span>
                        </div>
                }

                <img src="icons/prIntermediate.png" alt="" width="15px" height="15px" />
                &nbsp;
                <span>{subtrip.passings[subtrip.passings.length - 1].name}</span>

            </div>
        );
    }

    renderLastSubtrip(trip, subtrip) {
        const { getLogo } = this.context;

        return (
            <div key={`last-subtrip-${trip.startPlace.name}-${trip.endPlace.name}-${subtrip.order}`}>
                {
                    subtrip.isWalking ?
                        <div className="padding-top-10 padding-bottom-10">
                            <img src="icons/walking.png" alt="" width="20px" height="20px" />
                            <span>Ir a pé {subtrip.walkingTime}, {subtrip.distance}m</span>
                        </div>
                        :
                        //TO DO: Use transport types here
                        <div className="padding-top-10 padding-bottom-10" >
                            <img src="icons/bus.png" alt="" width="20px" height="20px" />
                            &nbsp;
                            <img src={getLogo(subtrip.provider)} alt={subtrip.provider} width="20px" height="20px" />
                            &nbsp;
                            <span>{subtrip.lineCode} {subtrip.passings[0].destination}</span>
                        </div>
                }

                <img src="icons/prDestination.png" alt="" width="20px" height="20px" />
                &nbsp;
                <b>{subtrip.arrivalTimeToShow} - {trip.endPlace.name}</b>

            </div>
        );
    }

    render() {
        return (
            <Container fluid className="route-detailed-view-container">
                {this.renderDisplay()}
            </Container>
        );
    }
}